export default __webpack_public_path__ + "static/media/JanicaLovelace.a66b90b7.png";